import { SxProps } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';

type Props = { label: string; sx?: SxProps };

const WsInfoFrameLabel = (props: Props) => {
  return (
    <Typography
      color="primary"
      // variant="h6"
      sx={{
        paddingLeft: 1,
        fontSize: 14,
        fontWeight: 'bold',
        ...props.sx,
      }}
    >
      {props.label}
    </Typography>
  );
};

export default WsInfoFrameLabel;
